import { render } from "./BasicInputText.vue?vue&type=template&id=5bedfeb4&scoped=true"
import script from "./BasicInputText.vue?vue&type=script&lang=js"
export * from "./BasicInputText.vue?vue&type=script&lang=js"

import "./BasicInputText.vue?vue&type=style&index=0&id=5bedfeb4&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bedfeb4"]])

export default __exports__